import {
  getListInternalDocsQueryParams,
  InternalDocumentDetail,
} from "core/http/service/internalDocument/resTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  [key: string]: {
    status?: ReduxStateType;
    data?: InternalDocumentDetail[];
    categoryName?: string;
    totalRecords?: number;
  };
}

const initialState: InitialState = {};

const getListInternalDocsSlice = createSlice({
  name: "getListInternalDocs",
  initialState,
  reducers: {
    getListInternalDocsStart: (
      state,
      action: PayloadAction<{
        type: string;
        params?: getListInternalDocsQueryParams;
      }>
    ) => {
      const data = state[action.payload.type]?.data ?? [];
      state[action.payload.type] = {
        status: ReduxStateType.LOADING,
        data,
        totalRecords: 0,
        categoryName: state[action.payload.type]?.categoryName ?? "",
      };
    },
    getListInternalDocsSuccess: (
      state,
      action: PayloadAction<{
        type: string;
        data: InternalDocumentDetail[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state[action.payload.type] = {
        status: ReduxStateType.SUCCESS,
        data: [...state[action.payload.type].data, ...action.payload.data],
        categoryName: action.payload.categoryName,
        totalRecords: action.payload.totalRecords,
      };
    },
    getListInternalDocsFailed: (
      state,
      action: PayloadAction<{ type: string }>
    ) => {
      state[action.payload.type] = {
        status: ReduxStateType.ERROR,
        data: [],
      };
    },
    resetListInternalDocs: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = {};
    },
  },
});

export const {
  getListInternalDocsStart,
  getListInternalDocsSuccess,
  getListInternalDocsFailed,
  resetListInternalDocs,
} = getListInternalDocsSlice.actions;

export default getListInternalDocsSlice.reducer;
